import { Box } from "@mui/material";

const imgIllustration = "/assets/emailcampaign.png";

export default function EmailCampaignContent() {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", mt: 2, px: 2 }}>
      <Box
        component="img"
        src={imgIllustration}
        alt=""
        sx={{ width: 216, height: "auto", objectFit: "contain" }}
      />
    </Box>
  );
}
